const principles = [
  {
    title: "Usability",
    description: "Every interface is crafted with the end user in mind. Intuitive interactions, clear information architecture, and thoughtful design patterns ensure that software feels natural and effortless to use.",
  },
  {
    title: "Stability",
    description: "Reliability is non-negotiable. Systems are built to handle real-world conditions gracefully, with robust error handling, comprehensive testing, and defensive coding practices that prevent failures before they occur.",
  },
  {
    title: "Technical Excellence",
    description: "Code quality, maintainability, and adherence to engineering best practices are the standards by which every project is measured. Shortcuts that compromise long-term integrity are never acceptable.",
  },
  {
    title: "Innovation",
    description: "A culture of curiosity and continuous learning drives the exploration of new technologies, patterns, and methodologies. The team actively seeks better ways to solve problems and deliver value.",
  },
  {
    title: "Reliability",
    description: "Delivering on commitments with consistency and precision builds trust. Every system is engineered to perform dependably over time, with predictable behavior and minimal surprises.",
  },
];

export default function PrinciplesSection() {
  return (
    <section className="relative w-full py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="mb-16">
          <p className="text-sm tracking-[0.25em] uppercase text-primary-600 font-label font-medium mb-4">Our Foundation</p>
          <h2 className="font-heading text-3xl md:text-4xl font-medium text-foreground-900">
            Core Principles
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {principles.map((item) => (
            <div
              key={item.title}
              className="p-8 rounded-lg bg-background-50 border border-background-200/60"
            >
              <div className="w-2 h-2 rounded-full bg-accent-400 mb-5"></div>
              <h3 className="font-heading text-xl font-medium text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed font-light">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}